<template>    
    <v-container v-if="examSessions && !loading" :class="{'py-3 px-0': phoneOnly, 'py-6': pcOnly}">
        <v-list v-if="examSessions && examSessions.length" class="py-0">
            <template v-for="session in examSessions">
                <v-list-item v-show="session.exam" :key="session.id" class="py-1" :class="{'bordered rounded mb-3 px-6': pcOnly}" v-on="phoneOnly && session.corrected ? {click: ()=>{openExam(session.exam)}} : {}" v-ripple="phoneOnly && session.corrected ? {class: 'ripple--color'} : false">
                    <v-list-item-icon class="my-auto grey lighten-3 pa-3 rounded" :class="{'me-5': phoneOnly}">
                        <v-icon size="25" color="strong-text">mdi-clipboard{{session.succeeded ? '-check' : '-alert'}}-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="strong-text--text medium-text">{{session.exam.name}}</v-list-item-title>
                        <v-list-item-subtitle>
                            <v-chip v-if="session.start_time" label small outlined class="ltr-dir px-2 me-2" style="height: 22px;">{{dateTimeFormat(session.start_time, true).split(' ')[0]}}</v-chip>
                            <v-chip v-if="session.exam && !session.exam.show_result" label small color="muted" class="px-2" style="height: 22px;" outlined>
                                <v-icon size="15" class="me-1">mdi-alert-circle-outline</v-icon>
                                <span>لم تظهر النتيجة</span>
                            </v-chip>
                            <v-chip v-else-if="session.corrected" label small :color="session.succeeded ? 'success' : 'error'" class="px-2" style="height: 22px;">{{session.succeeded ? 'ناجح' : 'راسب'}}</v-chip>
                            <v-chip v-else label small color="muted" class="px-2" style="height: 22px;" outlined>
                                <v-icon size="15" class="me-1">mdi-alert-circle-outline</v-icon>
                                <span>لم يتم التصحيح</span>
                            </v-chip>
                            <v-chip v-if="session.total_mark" label small :color="session.succeeded ? 'success' : 'error'" outlined class="ltr-dir px-2 ms-2" style="height: 22px;">{{session.correction_mark}} <b class="mx-2">/</b> {{session.total_mark}}</v-chip>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon v-if="session.corrected && session.exam && session.exam.show_result" class="my-auto ms-2">
                        <v-btn v-if="pcOnly" color="primary" depressed @click="openExam(session.exam)">
                            تفاصيل النتيجة
                            <v-icon right style="opacity: 0.6">mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-icon size="20" color="grey" v-else>mdi-chevron-left</v-icon>
                    </v-list-item-icon>
                </v-list-item>
                <v-divider v-if="phoneOnly" inset :key="'divider-' + session.id" style="opacity: 0.6"></v-divider>
            </template>
        </v-list>

        <div v-else class="pa-4 pa-lg-0">
            <v-alert type="info" color="blue-grey" text class="mb-0">
                <div class="details-text">لم تخُض أي امتحانات حتى الآن أو ربما لم تظهر نتائج امتحاناتك.</div>
            </v-alert>
        </div>
        
    </v-container>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: "Courses",
    components: {
        
    },
    props: {
        getUrl: {required: true}
    },
    data(){
        return {
            examSessions: null,

            loading: false,
            openingExam: false,
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        openingExam(loading){
            this.setLinearLoading(loading);
        }
    },
    methods: {
        ...GlobalMethods,
        getExams(){
            if (!this.loading){
                this.loading = true;
                const url = this.getUrl;
                this.$store.dispatch('fastGetAction', {url}).then(response=>{
                    this.loading = false;
                    this.examSessions = response.data.data;

                }).catch(()=>{
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
        openExam(exam){
            const exam_code = exam.exam_code;
            // get exam details
            if (!this.openingExam){
                this.openingExam = true;
                this.$store.dispatch('fastGetAction', {url: `/exams/details?exam_code=${exam_code}`}).then(response=>{
                    this.openingExam = false;
                    const examData = response.data.data;
                    window.setTimeout(()=>{
                        this.$router.push({name: 'exams', params: {examData: examData}})
                    }, 600);

                }).catch(error=>{
                    this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                    this.openingExam = false;
                })
            }
        },
    },
    mounted(){
        this.getExams();
    }
};
</script>